import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import "./review.scss";
import ApplicationStatusChip from "../../../components/StatusChip/ApplicationStatusChip";
import { getApplicationStatusStyle } from "../../../constants/statusStyles";
import Label from "../../../components/Label/Label";
import KeyboardArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openRow, setOpenRow] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const toggleSection = (rowId, section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [section]: !prev[rowId]?.[section],
      },
    }));
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="review-audit-table-container"
        sx={{ scrollbarGutter: "auto" }}
      >
        <Table stickyHeader sx={{ tableLayout: "auto", width: "100%" }}>
          <TableHead positon="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="audit-table-header-cell">
                Event Name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Batch ID
              </TableCell>
              {/* <TableCell className="audit-table-header-cell">
                Batch Date
              </TableCell> */}
              <TableCell className="audit-table-header-cell">
                Field name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Previous Value
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated Value
              </TableCell>

              <TableCell className="audit-table-header-cell">
                Updated status
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated by{" "}
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated on
              </TableCell>
              {/* <TableCell className="audit-table-header-cell">Action</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {
              // openData &&

              data?.data?.results.map((row) => (
                <>
                  <TableRow key={row}>
                    <TableCell sx={{ fontSize: 14 }}>{row.action }</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.batch_id }</TableCell>
                    {/* <TableCell sx={{ fontSize: 14 }}>
                      {row.batch_date }
                    </TableCell> */}

                    <TableCell sx={{ fontSize: 14 }}>
                      {row.parameter_name }
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.previous_value }
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.updated_value }
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {getApplicationStatusStyle(row.status) ? (
                        <ApplicationStatusChip status={row.status} sx={{ minWidth: 120 }} />
                      ) : (
                        <Chip
                          label={row.status}
                          className="review-status-chip status-chip status-chip-color-gray"
                        />
                      )}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.updated_by }
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.updated_at }
                    </TableCell>
                    {/* <TableCell>
                      <IconButton size="small" onClick={handleClick}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        PaperProps={{
                          sx: {
                            boxShadow: "none",
                            border: "1px solid #ccc",
                            padding: 0,
                            minWidth: "100px",
                            backgroundColor: "transparent",
                          },
                        }}
                        MenuListProps={{
                          sx: {
                            padding: 0,
                            backgroundColor: "white",
                            borderRadius: 0,
                          },
                        }}
                      >
                        {moreOption?.map((option) => (
                          <MenuItem
                            sx={{ py: 0.4 }}
                            key={option}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClose();
                              handleMenuOption(option, row);
                            }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                    </TableCell> */}
                  </TableRow>
                </>
              ))
            }
            {!data?.loader && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={tableHeaders?.length || 8} align="center">
                  <Label color="textSecondary" text={"No data found"}></Label>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
